import { createFileRoute, Link, Outlet, useRouterState } from "@tanstack/react-router";
import { GraduationCap, LayoutDashboard, FolderOpen, ClipboardList, Award, User } from "lucide-react";
import { cn } from "@/lib/utils";

export const Route = createFileRoute("/_authenticated/portal/student")({
  component: StudentLayout,
});

const tabs = [
  { to: "/portal/student", label: "Dashboard", icon: LayoutDashboard, exact: true },
  { to: "/portal/student/workspace", label: "Workspace", icon: FolderOpen },
  { to: "/portal/student/assignments", label: "Assignments", icon: ClipboardList },
  { to: "/portal/student/portfolio", label: "Portfolio", icon: Award },
  { to: "/portal/student/profile", label: "Profile", icon: User },
];

function StudentLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  return (
    <div className="space-y-6">
      <header>
        <p className="flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-gold">
          <GraduationCap className="h-3.5 w-3.5" /> Student portal
        </p>
        <h2 className="mt-1 font-display text-2xl text-navy">Your law studies workspace</h2>
      </header>

      <nav className="flex flex-wrap gap-2 border-b border-border pb-3">
        {tabs.map((t) => {
          const active = t.exact ? pathname === t.to : pathname.startsWith(t.to);
          return (
            <Link
              key={t.to}
              to={t.to as any}
              className={cn(
                "inline-flex items-center gap-2 rounded-md px-3 py-2 text-sm transition-colors",
                active ? "bg-navy text-navy-foreground" : "text-foreground/80 hover:bg-muted",
              )}
            >
              <t.icon className="h-4 w-4" />
              {t.label}
            </Link>
          );
        })}
      </nav>

      <Outlet />
    </div>
  );
}
